import * as React from "react";
import { SVGProps } from "react";
export const BookmarkIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M5.91699 14.812L9.99999 13.083L14.083 14.812V4.25H5.91699V14.812ZM5.39599 16.979C5.10399 17.1043 4.82599 17.08 4.56199 16.906C4.29866 16.7327 4.16699 16.4863 4.16699 16.167V4.25C4.16699 3.764 4.33699 3.35067 4.67699 3.01C5.01766 2.67 5.43099 2.5 5.91699 2.5H14.083C14.569 2.5 14.9823 2.67 15.323 3.01C15.663 3.35067 15.833 3.764 15.833 4.25V16.167C15.833 16.4863 15.7013 16.7327 15.438 16.906C15.174 17.08 14.896 17.1043 14.604 16.979L9.99999 14.979L5.39599 16.979Z"
            fill="currentColor"
        />
    </svg>
);
BookmarkIcon.displayName = "BookmarkIcon";
